/**
 * Job event category type object model.
 */
export default class JobEventCategoryType {
	constructor(public readonly id: string) {}

	/**
	 * Convert string to LeadEventTypeObject.
	 * @param {string} string
	 * @return {LeadEventTypeObject}
	 */
	public static fromString(string: string): JobEventCategoryType {
		return new JobEventCategoryType(string)
	}

	public static getAllCategories(): JobEventCategoryType[] {
		return [
			JobEventCategoryType.fromString("Contact"),
			JobEventCategoryType.fromString("Status"),
			JobEventCategoryType.fromString("Notes"),
			JobEventCategoryType.fromString("Reminders"),
			JobEventCategoryType.fromString("Appointments"),
			JobEventCategoryType.fromString("Files"),
			JobEventCategoryType.fromString("Job Updates"),
			JobEventCategoryType.fromString("Quotes"),
			JobEventCategoryType.fromString("Surveys")
		]
	}

	getLabel() {
		return this.id;
	}
}